import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import Carousel from 'components/Core/Carousel';
import ServiceCard from 'components/ServiceCard';

const mediaQueries = {
  sm: '(max-width: 767px)',
  md: '(min-width: 768px) and (max-width: 1023px)',
  lg: '(min-width: 1024px)',
};

const OtherServices = ({ title, categories, onClickService }) => {
  const renderOtherService = (serviceCat) => {
    return (
      <div key={serviceCat.id} className="flex-full max-w-full lg:flex-1/3 lg:max-w-1/3 px-3 my-4 h-98per">
        <ServiceCard {...serviceCat} rigidHeight onServiceClickCB={onClickService} />
      </div>
    );
  };
  return (
    <div className="u-block-margins">
      <div className="container mx-auto px-4">
        <h2 className="h3 text-basic-700 mb-4 lg:mb-8">{title}</h2>
        <Media queries={mediaQueries} defaultMatches={{ lg: true }}>
          {(matches) => {
            if (matches.lg) {
              return <div className="flex flex-wrap -mx-4">{categories.map(renderOtherService)}</div>;
            }
            if (matches.md) {
              return (
                <Carousel
                  items={categories}
                  totalNumber={categories.length}
                  visibleSlides={2}
                  slideRenderer={renderOtherService}
                />
              );
            }
            return <Carousel items={categories} totalNumber={categories.length} slideRenderer={renderOtherService} />;
          }}
        </Media>
      </div>
    </div>
  );
};

OtherServices.defaultProps = {
  title: 'Other Activities',
  categories: [],
  onClickService: () => {},
};

OtherServices.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.shape({})),
  onClickService: PropTypes.func,
};
export default OtherServices;
